import Vue from 'vue';
import Router from 'vue-router'
import PhotoGridView from './views/PhotoGridView.vue';
import PhotoView from './views/PhotoView.vue';
import UserView from './views/UserView.vue';
import AlbumView from './views/AlbumView.vue'

Vue.use(Router);

export default new Router({
    base: "/",
    routes: [
        {
            path: '/',
            name: 'photogrid',
            component: PhotoGridView
        },
        {
            path: '/photo/:id',
            name: 'photo-view',
            component: PhotoView
        },
        {
            path: '/user',
            name: 'user',
            component: UserView
        },
        {
            path: '/albums',
            name: 'albums',
            component: AlbumView
        },
    ]
});